import firebase from 'firebase/compat/app';
import STORE_CONSTANTS, { PRODUCTS_DOC, PRODUCTS_VERSION } from '../constants';
import withoutNulls from '../../api/search/withoutNulls';

export { PRODUCTS_DOC, PRODUCTS_VERSION };

const productConverter = {
  toFirestore(app: V3.Product): firebase.firestore.DocumentData {
    return withoutNulls({ ...app });
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<V3.Product>,
    options: firebase.firestore.SnapshotOptions,
  ): V3.Product {
    const data: V3.Product = {
      ...snapshot.data(options),
    };

    return data;
  },
};

const getProductsRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.CONTENT_DISTRIBUTIONS_COLLECTION)
    .doc(PRODUCTS_DOC)
    .collection(PRODUCTS_VERSION)
    .withConverter(productConverter);
};

export default getProductsRef;
